// extracted by mini-css-extract-plugin
export default {"Product":"PopularProduct_Product__sLx7I","ProductImg":"PopularProduct_ProductImg__gPRjb"};